function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 5.5H3.5V8.5H9.5V5.5ZM3.5 4H9.5C10.3438 4 11 4.6875 11 5.5V8.5C11 9.34375 10.3438 10 9.5 10H3.5C2.6875 10 2 9.34375 2 8.5V5.5C2 4.6875 2.6875 4 3.5 4ZM16.5 5.5H14.5V13.5H16.5V5.5ZM14.5 4H16.5C17.3438 4 18 4.6875 18 5.5V13.5C18 14.3438 17.3438 15 16.5 15H14.5C13.6875 15 13 14.3438 13 13.5V5.5C13 4.6875 13.6875 4 14.5 4ZM5.5 13.5V15.5H9.5V13.5H5.5ZM4 13.5C4 12.6875 4.6875 12 5.5 12H9.5C10.3438 12 11 12.6875 11 13.5V15.5C11 16.3438 10.3438 17 9.5 17H5.5C4.6875 17 4 16.3438 4 15.5V13.5Z",
  fill: "currentColor"
});

function SvgManageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageIcon);
export default __webpack_public_path__ + "static/media/manage-icon.2522da0e.svg";
export { ForwardRef as ReactComponent };